import { ref } from '@vue/composition-api'
import router from '@/shared/router'
import i18n from '@hw-core/libs/i18n'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import { fetchContract, saveContract } from '@/shared/services/contractService'

export default function useContractView() {
  // Use toast
  const toast = useToast()
  const contractData = ref(null)

  const getData = () => {
    fetchContract(router.currentRoute.params.id)
      .then(async res => {
        contractData.value = res
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching contract',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        router.push({ name: 'apps-contract-list' })
      })
  }

  const updateContract = ({ data, callback }) => {
    saveContract(data)
      .then(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('success'),
            text: 'Sopimus päivitetty',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('error'),
            text: i18n.t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
      .finally(() => {
        callback()
        getData()
      })
  }

  getData()

  return {
    contractData,
    updateContract,
  }
}
